import { render } from "./LotButtonLink.vue?vue&type=template&id=60e25b2e&scoped=true&ts=true&lang=pug"
import script from "./LotButtonLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotButtonLink.vue?vue&type=script&lang=ts&setup=true"

import "./LotButtonLink.vue?vue&type=style&index=0&id=60e25b2e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e25b2e"]])

export default __exports__